import { Button, Card, Form } from 'antd';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { useNavigate } from 'react-router';

import { useResource } from 'app/common/api';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { appRoute } from 'app/railways/router/routes';
import { Loading } from 'app/ui';

import {
  TNewTariffProfile,
  TTariffProfile,
} from '../../../core/tariff-profile';
import { addTariffProfileRequest } from '../../../requests/add-tariff-profile.request';
import { TariffProfileFields } from '../tariff-profile-fields/tariff-profile.fields';
import { TTariffProfileMetaFormFields } from '../tariff-profile-fields/types';

export const AddTariffProfile = observer(() => {
  const notify = usePageNotify();

  const navigate = useNavigate();

  const addTariffProfileResource = useResource<
    TNewTariffProfile,
    TTariffProfile
  >({
    request: addTariffProfileRequest,
    errorNotify: notify,
    onDone(tariffProfile) {
      navigate(
        appRoute.TARIFF_PROFILES.DETAILS.buildPath({
          tariffProfileId: tariffProfile.id,
        }),
      );
    },
  });

  const [form] = Form.useForm();

  const initialValues: TTariffProfileMetaFormFields = {
    name: '',
    trainType: null,
    dateType: 'always',
    dateFrom: moment().startOf('day'),
    dateTo: moment().endOf('day'),
  };

  const handleSubmit = (fields: TTariffProfileMetaFormFields) => {
    if (fields?.dateType === 'always') {
      addTariffProfileResource.send({
        name: fields.name,
        trainType: fields.trainType,
        rules: [],
      });

      return;
    }

    if (fields?.dateType === 'tripDate') {
      addTariffProfileResource.send({
        name: fields.name,
        trainType: fields.trainType,
        fromTripDate: fields.dateFrom?.toJSON(),
        toTripDate: fields.dateTo?.toJSON(),
        rules: [],
      });
      return;
    }

    if (fields?.dateType === 'payDate') {
      addTariffProfileResource.send({
        name: fields.name,
        trainType: fields.trainType,
        fromPayDate: fields.dateFrom?.toJSON(),
        toPayDate: fields.dateTo?.toJSON(),
        rules: [],
      });

      return;
    }
  };

  return (
    <Loading active={addTariffProfileResource.isLoading}>
      <Form
        layout="vertical"
        form={form}
        initialValues={initialValues}
        onFinish={handleSubmit}
      >
        <Card size="small">
          <div style={{ maxWidth: '50%' }}>
            <TariffProfileFields />
          </div>
        </Card>
        <Card
          size="small"
          style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}
        >
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Card>
      </Form>
    </Loading>
  );
});
